import { render } from "./GroceryView.vue?vue&type=template&id=1706af80&scoped=true"
import script from "./GroceryView.vue?vue&type=script&lang=js"
export * from "./GroceryView.vue?vue&type=script&lang=js"

import "./GroceryView.vue?vue&type=style&index=0&id=1706af80&scoped=true&lang=css"
import "./GroceryView.vue?vue&type=style&index=1&id=1706af80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1706af80"]])

export default __exports__